import React from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import InventoryTransferTableSection from "../../components/inventory/transfer/InventoryTransferTableSection";

const InventoryTransfersPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <InventoryTransferTableSection/>
    </DefaultLayout>
  );
};

export default InventoryTransfersPage;
